import React from 'react'
import {
  deleteTemplate,
  renameTemplate
} from 'report-components/lib/reducers'
import {withToggles, withDialogError} from 'startlibs/lib/hocs'
import {Errors, Form, withForm, TextInput} from 'startlibs/lib/form'
import {Dialog, Button} from 'startlibs/lib/components'

@withDialogError
@withToggles('confirmClose')
export class ManageTemplatesDialog extends React.Component {

  static defaultProps = {
    title: 'Manage report templates',
    type: 'Report',
    desc: 'Templates you have access to are listed below. You can rename or remove a template and no report data will' +
    ' be lost. Changes will also apply to others using the template.'
  }

  checkConfirmClose = () => {
    if (this.openBoxes.length)
      this.props.confirmClose.open()
    else
      this.props.closeDialog()
  }

  openBoxes = []
  addBox = (id) => {
    this.openBoxes = this.openBoxes.concat(id)
  }
  removeBox = (id) => {
    this.openBoxes = this.openBoxes.filter(_ => _ !== id)
  }

  render() {
    const {templates, title, type, desc, closeDialog, confirmClose} = this.props
    return <Dialog
      className='manage-template-dialog'
      title={title}
      confirm={this.checkConfirmClose}
      closeDialog={this.checkConfirmClose}
    >
      <Dialog.Content>
        <p>
          {desc}
        </p>
        {templates.map(template =>
          <TemplateEditBox
            addBox={this.addBox}
            type={type}
            removeBox={this.removeBox}
            key={template.templateId}
            className="editable-box"
            formProperties={template}
            template={template}
          />
        )}
        {templates.length === 0 && <div className="no-templates">
          <h3>You currently have no templates.</h3>
          <p>You can create one from the {type} Editor and reuse it in multiple reports.</p>
        </div>
        }
      </Dialog.Content>

      <Dialog.Footer>
        <button onClick={this.checkConfirmClose}>Close</button>
      </Dialog.Footer>

      {
        confirmClose.isOpen &&
        <Dialog
          title="Your changes won't be saved"
          closeDialog={confirmClose.close}
        >
          <Dialog.Content>
            The changes made on this screen were not saved. Would you like to quit anyway?
          </Dialog.Content>
          <Dialog.Footer>
            <button type="button" onClick={confirmClose.close}>Cancel</button>
            <button className="alert with-loader" onClick={closeDialog} type="submit">Confirm</button>
          </Dialog.Footer>
        </Dialog>
      }
    </Dialog>
  }
}

@withToggles('editing', 'deleteDialog')
@withForm(deleteTemplate)
class TemplateEditBox extends React.Component {

  componentWillUnmount() {
    this.props.removeBox(this.props.template.templateId)
  }

  componentWillReceiveProps(newProps) {
    if (newProps.editing.isOpen !== this.props.editing.isOpen) {
      this.props.form.connector.clearErrors()
      if (newProps.editing.isOpen) {
        this.props.addBox(this.props.template.templateId)
      } else {
        this.props.removeBox(this.props.template.templateId)
      }
    }
    if (newProps.template !== this.props.template) {
      this.props.editing.toggle()
    }
  }

  render() {
    const {template, editing, type, deleteDialog, form} = this.props
    return (
      <div>
        {
          editing.isOpen ?
            <OpenTemplateEditBox
              template={template}
              close={editing.close}
              formProperties={template}
              toggleDeleteDialog={deleteDialog.toggle}
            /> :
            <ClosedTemplateEditBox
              template={template}
              toggleEditing={editing.toggle}
              toggleDeleteDialog={deleteDialog.toggle}
              className="closed-box"
            />
        }
        {
          deleteDialog.isOpen &&
          <Dialog
            title="Confirm delete template"
            form={form}
            closeDialog={deleteDialog.close}
          >
            <Dialog.Content>
              You are about to delete the template <strong>{template.label}</strong>.
              No {(type || '').toLowerCase()} data will be lost in
              the process,
              but the template will no longer be available. Confirm deletion?
            </Dialog.Content>
            <Dialog.Footer>
              <Form form={form} alwaysSave>
              <Button type="button" onClick={deleteDialog.close}>Cancel</Button>
              <Button alert isLoading={form.isLoading} type="submit">Delete</Button>
              </Form>
            </Dialog.Footer>
            <Errors form={form}/>
          </Dialog>
        }
      </div>
    )
  }
}

@withForm(renameTemplate)
class OpenTemplateEditBox extends React.Component {

  preValidation = (success) => {
    if (success.label.length < 1) {
      return {errors: {label: ['Template name is required.']}}
    } else {
      return {success}
    }
  }

  checkKey = (e) => {
    if (e.key === 'Escape') {
      e.preventDefault()
      this.props.close()
    } else if (e.key === 'Enter') {
      e.preventDefault()
      e.stopPropagation()
      this.props.form.connector.handleSubmit(e)
    }
  }

  render() {
    const {form, toggleDeleteDialog, close} = this.props
    return (
      <div className="editable-box" onKeyDown={this.checkKey}>
        <Form form={form} preValidation={this.preValidation} onSuccess={close}>
          <TextInput
            form={form}
            path="label"
            autoFocus
            constraint="capitalize"
            label="Template name"
          />
          <div className="editable-box-footer">
            <div>
              <Button hover="alert" icon="delete" onClick={toggleDeleteDialog}>Delete</Button>
            </div>
            <div>
              <Button onClick={close}>Cancel</Button>
              <Button highlight isLoading={form.isLoading} type="submit">Save</Button>
            </div>
          </div>
          <Errors form={form}/>
        </Form>
      </div>
    )
  }
}

const ClosedTemplateEditBox = ({template, toggleEditing, toggleDeleteDialog}) => (
  <div className="editable-box closed" onClick={toggleEditing}>
    {template.label}
    <button className="small-button" onClick={e => {
      e.stopPropagation()
      toggleEditing(e)
    }}>
      Edit
    </button>
  </div>
)



// WEBPACK FOOTER //
// ./~/report-components/src/modules/template/ManageTemplatesDialog.jsx